<template>
  <div class="card shadow-sm border-0">
    <div class="card-header bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <h3 style="display: inline; margin-right: 15px">Topics</h3>
        <AddTopic />
      </div>
    </div>
    <div class="card-body">
      <div v-if="!loading" class="table-responsive w-100">
        <table class="table table-bordered settings-table">
          <thead>
            <tr class="">
              <th></th>
							<th>Posición</th>
              <th>Nombre</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <draggable
            v-if="topics.length"
            v-model="topics"
            group="topics"
            item-key="UUID"
            @end="updateOrder"
            tag="tbody"
          >
            <template #item="{ element, index }">
              <TopicRow :topic="element" :position="index + 1" />
            </template>
          </draggable>
          <tbody v-else>
            <tr>
              <td colspan="5" class="text-center text-muted">No hay temáticas disponibles.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="text-center py-5">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <div>Cargando información</div>
    </div>
    </div>
  </div>
</template>

<script>
import AddTopic from "@/components/Blog/elements/Topics/AddTopic.vue";
import TopicRow from "@/components/Blog/elements/Topics/TopicRow.vue";
import TopicService from "@/services/topic.service.js";
import draggable from "vuedraggable";
import Swal from "sweetalert2";

export default {
  name: "topics",
  components: {
    AddTopic: AddTopic,
    TopicRow: TopicRow,
    draggable,
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  data() {
    return {
      topics: [],
      loading: true,
      dragging: false,
    };
  },
  methods: {
    async getTopics() {
      this.loading = true;
      const response = await TopicService.getAllTopics();
      this.topics = response.data.sort((a, b) => a.position - b.position);
      this.loading = false;
    },
  async updateOrder() {
    try {
      Swal.fire({
        title: "Guardando...",
        text: "Por favor espera mientras se guarda el orden.",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });

      for (let i = 0; i < this.topics.length; i++) {
        this.topics[i].position = i + 1;
      }

      const response = await TopicService.updateTopicsOrder(
        this.topics.map((t) => ({
          UUID: t.UUID,
          position: t.position,
        }))
      );

      Swal.close();

      if (response.status === 200) {
        await Swal.fire({
          icon: "success",
          title: "Orden actualizado",
          text: "El orden de las temáticas se ha guardado correctamente.",
          confirmButtonColor: "#0091ff",
        });
      } else {
        throw new Error("Respuesta inválida");
      }
    } catch (error) {
      Swal.close();
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Hubo un problema al actualizar el orden.",
        confirmButtonColor: "#d33",
      });
    }
  },
  },
  created() {
    this.getTopics();
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
  },
};
</script>
